<template>
  <Row justify="center" type="flex">
    <Col span="24">
      <div class="about_content">
        <!-- 关于我们 -->
        <div class="about-section-wrap">
          <div class="about-left">
            <div class="title-en">ABOUT US</div>
            <div class="title-line"></div>
            <div class="title-cn">关于我们</div>

            <div class="about-text">
              河南南秀智数科技有限公司（简称：南秀科技）成立于2017年，总部位于郑州市郑东新区龙子湖中原数据产业大厦。技术服务范围广泛，涵盖数字孪生平台、人工智能、集成电路、智能物联网、大数据、云计算、虚拟仿真软硬件，以及
              VR、AR、MR
              技术研发。公司将物联网、大数据与行业深度融合，为客户提供全流程数字化的管理工具和创新展示平台，助力行业效率与安全水平全面提升。公司以致力于建筑行业与消防安全数字化为宗旨，竭诚奉献领先的数字化产品与服务，至今已与中建、中铁、中交、中冶等100余家单位建立了良好的合作关系。
            </div>

            <div class="about-text">
              南秀科技自成立以来，专注于技术研发与创新应用。2019年，南秀科技被评为国家高新技术企业。2020年完成知识产权贯标工作，为企业发展提供了有力支撑。2021年，南秀科技被认定为郑州市大数据企业，并获得“专精特新”中小企业认证及AAA级信用等级认证。拥有9项发明专利、32项实用新型专利和58项软件著作权，SCI论文2篇、独立研发出40余项完全自主知识产权的产品。2023年5月，我司与中建五局共同研发的《工程项目数字孪生智能建造系统》荣获河南省科技厅科学技术一等奖。带领团队获得第二届全国大学生智能技术应用大赛一等奖；2024年公司与中建七局、中建五局共同申报的《工程项目数字孪生智能建造关键技术及应用》经河南省院士专家工作促进会认定，具有较高的市场推广应用潜力。该成果在工程项目数字孪生系统构建等方面有重大创新，达到国际先进水平，同时本项目荣获了 2024
              年中州建设科学技术奖一等奖；我司研发的实测实量智能管控系统平台通过二级等保评测；公司的数字孪生智慧平台通过SQuaRE(GB/T
              25000.51-2016)《系统与软件工程系统与软件质量要求和评价(SQuaRE)第51部分:就绪可用软件产品(RUSP)的质量要求和测试细则》评测。2024年在第一届住房城乡建设部智能建造工程技术创新中心智能建造大赛中，南秀科技参与研发的
              “基于人工智能的施工现场全场景关键技术及穿戴设备—AI 移动巡检安全帽”
              项目成功突围，荣获住建部智能建造大赛三类成果奖项，以及2025年豫建杯智能建造微创新技术大赛特等奖；公司先后被授予“河南省智能建造专业委员会委员单位”、荣获河南建筑业第四届供应链“十大优秀服务商”、荣获河南省建设信息管理协会“副会长单位”，深度参与《河南省建设工程智慧工地建设与评价标准》及《河南省建设工程智慧工地建设与评价共享交换数据标准》两项标准的制定。2025年带领企业深度参与共建河南省省级工程研究中心—河南省物证溯源数智化应用程研究中心。
            </div>
          </div>
        </div>

        <!-- 主营业务 -->
        <div class="business-wrap">
          <div class="title-en">MAIN BUSINESS</div>
          <div class="title-line"></div>
          <div class="title-cn">主营业务</div>

          <div class="card-list">
            <!-- 智慧工地管理平台 -->
            <div class="introduce">
              <div class="card-img">
                <img src="../../../static/img/AboutUs/gongdi.png" alt="" />
              </div>
              <div class="div_title">智慧工地管理平台</div>
              <div class="div_content">
                <div class="div_size1">
                  智慧工地数字孪生平台将先进的数字孪生技术与智慧工地管理深度融合，通过实时数据采集与虚拟模型的同步映射，全面实现工地的智能化监控与管理。平台不仅能够精准还原施工现场的每个细节，还能通过大数据和人工智能分析，为项目进度、安全管理和资源调度提供科学的决策支持。数字孪生平台的应用，大幅提升了工地的管理效率与安全性，为实现智能化、可视化的现代建筑施工开创了全新路径。
                </div>
              </div>
            </div>
            <!-- AI智能移动巡检 -->
            <div class="introduce">
              <div class="card-img">
                <img src="../../../static/img/AboutUs/ai.png" alt="" />
              </div>
              <div class="div_title">AI智能巡检</div>
              <div class="div_content">
                <div class="item-box">
                  <div class="div_size">AI移动巡检安全帽</div>
                  <div class="div_size1">
                    AI移动巡检安全帽融合了先进的人工智能算法和智能设备功能，专为提升工地安全与管理效率而设计。通过安全隐患识别、质量隐患识别、物料验收识别、人员信息识别。
                  </div>
                </div>
                <div class="item-box">
                  <div class="div_size">AI移动巡检记录仪</div>
                  <div class="div_size1">
                    将视觉大数据汇聚5G网络，以AI开启全场景智慧化应用，划时代的用“5G+AI”塑造了新一代5G记录仪，融入核心六大AI算法，同时兼顾支持安全隐患识别、质量隐患识别、物料验收识别、人员信息。
                  </div>
                </div>
                <div class="item-box">
                  <div class="div_size">AI超脑BOX</div>
                  <div class="div_size1">
                    AI超脑BOX，是一款智能软件算法和AI加速芯片相融合的微型服务器，32T超强算力，极高准确率，无误识别。
                    内置软件识别算法包括人脸、人体、车牌、车辆违停、烟雾烟火、佩戴安全帽、反光衣、安全带、安全绳、打电话、抽烟、工作服、离岗、睡岗、电瓶车、区域入侵、跌倒、摄像头遮挡等,使用部署方便，可应用于加油站、化工厂、智慧社区、环保、工地、厂区、校园、园区、景区等场景。
                  </div>
                </div>
              </div>
            </div>
            <!-- 光伏清扫机器人 -->
            <div class="introduce">
              <div class="card-img">
                <img src="../../../static/img/AboutUs/zhanting.png" alt="" />
              </div>
              <div class="div_title">光伏清扫机器人</div>
              <div class="div_content">
                <div class="item-box">
                  <div class="div_size">履带式光伏板清洁机器人</div>
                  <div class="div_size1">
                    履带式光伏清扫机器人，专为各类工商业厂房、山地、荒漠、屋顶光伏电站量身打造，依托稳固履带行走结构，适配复杂坡面、凹凸地面，全自动完成光伏板表面积灰、落叶、沙尘、鸟粪清理作业，大幅提升光伏板发电效率，降低人工清扫成本，是光伏电站日常运维必备清洁设备。
                  </div>
                </div>
                <div class="item-box">
                  <div class="div_size">壁挂式光伏板清洁机器人</div>
                  <div class="div_size1">
                    壁挂式光伏板清扫机器人搭载智能核心清洁系统，支持定时预约清扫，后台可调整清扫任务与强度，可全面清扫光伏板表面的灰尘、鸟粪、落叶等各类顽固污渍。配合高精度滚刷，实现无死角深度清洁。
                    采用太阳能自充电技术，利用光伏板余电或独立太阳能板为设备续航；当电量不足时，可立即停下充电，充满后继续未完成任务，实现全天候无人化值守
                    内置多重智能防护，当设备出现倾斜或遇到障碍物时，系统实时后台报警，运维人员可第一时间掌握异常情况并远程处理。
                  </div>
                </div>
              </div>
            </div>
            <!-- 实测实量系统平台 -->
            <div class="introduce">
              <div class="card-img">
                <img src="../../../static/img/AboutUs/scsl.png" alt="" />
              </div>
              <div class="div_title">实测实量系统平台</div>
              <div class="div_content">
                <div class="div_size1">
                  使用“软十硬”模式。利用智能靠尺、智能塞尺、顶板极差、智能回弹仪、智能测距仪、智能游标卡尺、智能卷尺、钢筋扫描仪、楼板测厚仪、阴阳角尺、实测实量机器人等作为数据信息采集端。配合手持移动端软件进行数据整理归类并通过数据库进行持久化存储和数据分析，并可通过云数据平台进行数据查询展示和解析，达到前中后端互通的一整套软硬件结合的数据采集系统。该系统可解决数据存储麻烦，保存管理难的问题，可有效进行数据管理措施的实施。避免多测、少测和重复测量，以此来达到规范化、精细化和自动化测量智能化工的效果，测量过程中可单人独立完成，减少人员调配难度，充分合理安排人员，加快施工进度提高工作效率，数据信息直接上传可支持多个参与方随时监督查阅，减少多方因数据差异导致的多种矛盾，有利于管理层对项目的整体管控。
                </div>
              </div>
            </div>
            <!-- 智慧展厅一体化 -->
            <div class="introduce">
              <div class="card-img">
                <img src="../../../static/img/AboutUs/zhanting.png" alt="" />
              </div>
              <div class="div_title">智慧展厅一体化</div>
              <div class="div_content">
                <div class="item-box">
                  <div class="div_size">VR虚拟现实</div>
                  <div class="div_size1">
                    集建筑安全教育、质量教育、绿色施工为一体的实体虚拟体验馆，结合VR眼镜实现了动态漫游，进行安全知识学习，视频观看，安全考核等技术培训。
                  </div>
                </div>
                <div class="item-box">
                  <div class="div_size">AR增强现实</div>
                  <div class="div_size1">
                    利用AR增强现实技术，AR虚拟工法样板可以使施工技术交底、岗前培训、质量检查和质量验收等具体化、规范化。与传统的质量样板展示相比，AR工法质量样板通俗易懂、生动有趣、造价低、不占地，而且绿色环保，优势明显。
                  </div>
                </div>
                <div class="item-box">
                  <div class="div_size">MR混合现实</div>
                  <div class="div_size1">
                    MR把真实世界和虚拟世界合成在一起，产生一个新的环境，使之形象化，物理和数字对象共存，实时的交互。混合现实不仅仅发生在真实世界或虚拟世界，而且把现实和虚拟现实融合到了一起，借助于沉浸技术包容了增强现实和增强虚拟。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  name: "CompanyProfile",
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
};
</script>

<style scoped>
/* 基础 */
.about_content {
  width: 100%;
  background: #fff;
  padding: 20px 15px;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* 关于我们 */
.about-section-wrap {
  max-width: 1200px;
  margin: 0 auto 80px;
}
.about-left {
  width: 100%;
}
.title-en {
  font-size: 36px;
  color: #ccc;
  line-height: 1.2;
  margin-bottom: 15px;
}
.title-line {
  width: 80px;
  height: 4px;
  background: #1966ff;
  margin: 20px 0;
}
.title-cn {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}
.about-text {
  font-size: 15px;
  color: #737373;
  line-height: 1.8;
  margin-bottom: 20px;
  text-align: justify;
}

/* 主营业务 */
.business-wrap {
  max-width: 1200px;
  margin: 0 auto;
}
.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-top: 40px;
}

/* 卡片 */
.introduce {
  width: 328px;
  background: #fff;
  box-shadow: 0 4px 75px rgba(0, 0, 0, 0.06);
  padding: 60px 20px 30px;
  position: relative;
  box-sizing: border-box;
}
.card-img {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.card-img img {
  height: 80px;
  width: auto;
}

.div_title {
  font-weight: 500;
  font-size: 20px;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
  margin-top: 19px;
}
.div_content {
  margin-top: 10px;
}
.item-box {
  margin-bottom: 15px;
}
.div_size {
  font-weight: 500;
  font-size: 16px;
  color: #333;
  margin-bottom: 6px;
}
.div_size1 {
  font-size: 14px;
  color: #737373;
  line-height: 1.7;
  text-align: justify;
}

/* ==================== 手机端适配 ==================== */
@media (max-width: 992px) {
  .title-en {
    font-size: 26px;
  }
  .title-cn {
    font-size: 24px;
  }
  .introduce {
    width: 100%;
    max-width: 380px;
    height: auto !important;
    padding: 60px 15px 25px;
  }
}

@media (max-width: 576px) {
  .about_content {
    padding: 15px 10px;
  }
  .title-en {
    font-size: 22px;
  }
  .title-cn {
    font-size: 22px;
  }
  .about-text {
    font-size: 14px;
  }
  .card-list {
    gap: 30px;
  }
  .introduce {
    width: 100%;
    max-width: 100%;
  }
  .div_title {
    font-size: 18px;
  }
  .div_size {
    font-size: 15px;
  }
  .div_size1 {
    font-size: 13px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AboutUs/CompanyProfile.vue